var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovernanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 2L64 18V50L34 66L4 50V18L34 2Z",
    fill: "#E3F2FD",
    stroke: "#003D7A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3334 35.1667C43.3334 41 39.2501 43.9167 34.3967 45.6083C34.1426 45.6945 33.8665 45.6903 33.6151 45.5967C28.7501 43.9167 24.6667 41 24.6667 35.1667V27C24.6667 26.6906 24.7897 26.3939 25.0085 26.1751C25.2272 25.9563 25.524 25.8333 25.8334 25.8333C28.1667 25.8333 31.0834 24.4333 33.1134 22.66C33.3606 22.4488 33.675 22.3328 34.0001 22.3328C34.3252 22.3328 34.6396 22.4488 34.8867 22.66C36.9284 24.445 39.8334 25.8333 42.1667 25.8333C42.4762 25.8333 42.7729 25.9563 42.9917 26.1751C43.2105 26.3939 43.3334 26.6906 43.3334 27V35.1667Z",
    stroke: "#003D7A",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceIcon);
export default __webpack_public_path__ + "static/media/GovernanceIcon.b769b241bd0db05742e3a296a3fda6da.svg";
export { ForwardRef as ReactComponent };